import type { FetcherType } from '@/app/_shared/utils/fetcher/types';
import type { IncomingHttpHeaders } from 'node:http';
import type { CalendarHolidaysInput, CalendarHolidaysResponse } from '@weberus/shared-types';

export const fetchCalendarHolidays =
  (fetcher: FetcherType) => (args: CalendarHolidaysInput, headers?: IncomingHttpHeaders) => {
    return fetcher<CalendarHolidaysResponse, CalendarHolidaysInput>({
      method: 'GET',
      url: '/display-site/calendar/holidays',
      params: {
        durationMonth: args?.durationMonth ?? 12,
      },
      headers: headers as Record<string, string>,
    });
  };
